import React, { Component } from 'react';
import { connect } from 'react-redux';

import { toggleGoogleInviteModal } from 'actions/google';
import { GOOGLE_INVITE_MODAL_VIEWED } from 'constants/events';
import * as analytics from 'utilities/analytics';
import { connectGoogleApp } from 'utilities/google';

import { INVITE_TEAM_VIEW_THRESHOLD } from '../../../../../shared/constants/invites';

import '../styles.less';

const PermissionPane = class extends Component {
  render() {
    const { error } = this.props;

    return (
      <div className="google-share-modal-backdrop" onClick={this.onClose}>
        <div className="google-share-modal" onClick={e => e.stopPropagation()}>
          <div className="close" onClick={this.onClose} />
          <h2 className="prompt">🔓 Who Viewed Your Video</h2>
          <p className="instructions">
            Invite {INVITE_TEAM_VIEW_THRESHOLD} people via email to Loom and
            instantly unlock the ability to see who views your video.
          </p>
          {!error && <div className="search" onClick={this.getPermissions} />}
          {!error && (
            <div className="dummy-list" onClick={this.getPermissions}>
              <div className="dummy-row">
                <div className="dummy-wrapper">
                  <div className="dummy-avatar" />
                </div>
                <div className="dummy-info">
                  <div className="dummy-name" />
                  <div className="dummy-email" />
                </div>
                <div className="dummy-check" />
              </div>
              <div className="dummy-row">
                <div className="dummy-wrapper">
                  <div className="dummy-avatar" />
                </div>
                <div className="dummy-info">
                  <div className="dummy-name" />
                  <div className="dummy-email" />
                </div>
                <div className="dummy-check" />
              </div>
              <div className="dummy-row">
                <div className="dummy-wrapper">
                  <div className="dummy-avatar" />
                </div>
                <div className="dummy-info">
                  <div className="dummy-name" />
                  <div className="dummy-email" />
                </div>
                <div className="dummy-check" />
              </div>
            </div>
          )}
          {error && (
            <div className="err">
              <div className="big-text">
                Uh oh! It Seems like we weren&apos;t able to connect your Google
                Account.
              </div>
              <div className="little-text">
                Loom never stores, alters or sends any information from your
                email account without your consent
              </div>
              <div className="retry" onClick={this.getPermissions}>
                Try Again
              </div>
            </div>
          )}
          <div className="hr" />
          <div className="goog-button" onClick={this.getPermissions}>
            <div className="gicon" />
            Invite using<span style={{ fontWeight: '600' }}>&nbsp;Gmail</span>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    analytics.track(GOOGLE_INVITE_MODAL_VIEWED, {
      modal_step: this.props.error ? 'connect_canceled' : 'connect_account',
    });
  }

  getPermissions = () => {
    connectGoogleApp();
  };

  onClose = () => {
    this.props.toggleGoogleInviteModal(false);
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleGoogleInviteModal: show => dispatch(toggleGoogleInviteModal(show)),
  };
};

export default connect(null, mapDispatchToProps)(PermissionPane);
